import { useState } from 'react'

import Sidebar from '../../components/Sidebar/Sidebar'

import {
  ChevronLeft,
  Plus,
  Trash2,
  GripVertical,
  Calendar,
  X,
} from 'lucide-react'

import './EditProductPage.scss'

export default function EditProductPage() {
  const [modifierGroups, setModifierGroups] =
    useState([
      {
        id: 1,
        title: 'Broth richness',
        type: 'single',
        required: true,
        expanded: true,
        options: [
          {
            id: 1,
            name: 'Regular',
            price: '0.00',
          },
          {
            id: 2,
            name: 'Rich / extra miso',
            price: '2.50',
          },
        ],
      },
      {
        id: 2,
        title: 'Add-ons',
        type: 'multiple',
        required: false,
        expanded: false,
        options: [],
      },
      {
        id: 3,
        title: 'Special instructions',
        type: 'text',
        required: false,
        expanded: false,
        options: [],
      },
    ])

  const toggleModifier = (id) => {
    setModifierGroups((prev) =>
      prev.map((group) =>
        group.id === id
          ? {
              ...group,
              expanded: !group.expanded,
            }
          : group
      )
    )
  }

  return (
    <div className="edit-product-layout">
      <main className="edit-product-page">
        <div className="edit-product-page__topbar">
          <div className="edit-product-page__breadcrumb">
            <button>
              <ChevronLeft size={18} />
              Back
            </button>

            <span>
              Product / Create product
            </span>
          </div>

          <div className="edit-product-page__actions">
            <button className="edit-product-page__cancel">
              Cancel
            </button>

            <button className="edit-product-page__save">
              Save changes
            </button>
          </div>
        </div>

        <div className="edit-product-page__content">
          <div className="edit-product-page__main">
            <section className="edit-product-card">
              <div className="edit-product-card__header">
                <h3>Basic information</h3>
              </div>

              <div className="edit-product-card__body">
                <div className="edit-product-image">
                  <img
                    src="https://images.unsplash.com/photo-1557872943-16a5ac26437e?q=80&w=1200&auto=format&fit=crop"
                    alt="Miso ramen"
                  />

                  <button>
                    <X size={18} />
                  </button>
                </div>

                <div className="edit-product-field">
                  <label>
                    Product name
                  </label>

                  <input
                    type="text"
                    defaultValue="Miso Ramen Noodles"
                  />

                  <p>
                    Shown as the product title
                    in the menu
                  </p>
                </div>

                <div className="edit-product-field">
                  <label>
                    Short description
                    <span>
                      optional
                    </span>
                  </label>

                  <textarea
                    rows={5}
                    defaultValue="Japanese egg noodles in soybean-based broth topped with grilled chicken, marinated egg, vegetables and seaweed."
                  />

                  <p>
                    Help customers understand
                    the product
                  </p>
                </div>
              </div>
            </section>

            <section className="edit-product-card">
              <div className="edit-product-card__header">
                <h3>Pricing</h3>
              </div>

              <div className="edit-product-card__body">
                <div className="edit-product-price">
                  <label>
                    Base price
                  </label>

                  <div className="edit-product-price__input">
                    <span>RM</span>

                    <input
                      type="text"
                      defaultValue="23.90"
                    />
                  </div>

                  <p>
                    Price from POS:
                    RM23.90
                  </p>
                </div>

                <div className="edit-product-radio-group">
                  <label>
                    With discount?
                  </label>

                  <div className="edit-product-radio-row">
                    <label>
                      <input
                        type="radio"
                        name="discount"
                      />
                      Yes
                    </label>

                    <label>
                      <input
                        type="radio"
                        name="discount"
                        defaultChecked
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="edit-product-radio-group">
                  <label>
                    With validity?
                  </label>

                  <div className="edit-product-radio-row">
                    <label>
                      <input
                        type="radio"
                        name="validity"
                        defaultChecked
                      />
                      Yes
                    </label>

                    <label>
                      <input
                        type="radio"
                        name="validity"
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="edit-product-dates">
                  <div className="edit-product-field">
                    <label>
                      Valid from
                    </label>

                    <div className="edit-product-date">
                      <input
                        type="text"
                        placeholder="dd/mm/yyyy"
                      />

                      <Calendar
                        size={18}
                      />
                    </div>
                  </div>

                  <div className="edit-product-field">
                    <label>
                      Valid until
                    </label>

                    <div className="edit-product-date">
                      <input
                        type="text"
                        placeholder="dd/mm/yyyy"
                      />

                      <Calendar
                        size={18}
                      />
                    </div>

                    <p>
                      Leave blank for no expiry
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="edit-product-card">
              <div className="edit-product-card__header">
                <h3>Modifier</h3>

                <button className="edit-product-add-btn">
                  <Plus size={16} />
                  Add group
                </button>
              </div>

              <div className="edit-product-card__body">
                <div className="modifier-groups">
                  {modifierGroups.map(
                    (group) => (
                      <div
                        key={group.id}
                        className="modifier-group"
                      >
                        <div
                          className="modifier-group__header"
                          onClick={() =>
                            toggleModifier(
                              group.id
                            )
                          }
                        >
                          <div className="modifier-group__left">
                            <GripVertical
                              size={16}
                            />

                            <div>
                              <h4>
                                {group.title}
                              </h4>

                              <p>
                                {group.type ===
                                'single'
                                  ? 'Single choice'
                                  : group.type ===
                                    'multiple'
                                  ? 'Multiple choice'
                                  : 'Free text'}
                              </p>
                            </div>
                          </div>

                          <span
                            className={`modifier-group__badge ${
                              group.required
                                ? 'modifier-group__badge--required'
                                : 'modifier-group__badge--optional'
                            }`}
                          >
                            {group.required
                              ? 'Required'
                              : 'Optional'}
                          </span>
                        </div>

                        {group.expanded && (
                          <div className="modifier-group__body">
                            <div className="edit-product-field">
                              <label>
                                Group name
                              </label>

                              <input
                                type="text"
                                defaultValue={
                                  group.title
                                }
                              />
                            </div>

                            <div className="modifier-group__settings">
                              <div className="edit-product-radio-group">
                                <label>
                                  Selection type
                                </label>

                                <div className="edit-product-radio-row">
                                  <label>
                                    <input
                                      type="radio"
                                      defaultChecked={
                                        group.type ===
                                        'single'
                                      }
                                    />
                                    Single choice
                                  </label>

                                  <label>
                                    <input
                                      type="radio"
                                      defaultChecked={
                                        group.type ===
                                        'multiple'
                                      }
                                    />
                                    Multi choice
                                  </label>

                                  <label>
                                    <input
                                      type="radio"
                                      defaultChecked={
                                        group.type ===
                                        'text'
                                      }
                                    />
                                    Free text
                                  </label>
                                </div>
                              </div>

                              <div className="edit-product-radio-group">
                                <label>
                                  Required?
                                </label>

                                <div className="edit-product-radio-row">
                                  <label>
                                    <input
                                      type="radio"
                                      defaultChecked={
                                        group.required
                                      }
                                    />
                                    Yes
                                  </label>

                                  <label>
                                    <input
                                      type="radio"
                                      defaultChecked={
                                        !group.required
                                      }
                                    />
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="modifier-options">
                              {group.options.map(
                                (
                                  option
                                ) => (
                                  <div
                                    key={
                                      option.id
                                    }
                                    className="modifier-option"
                                  >
                                    <GripVertical
                                      size={16}
                                    />

                                    <input
                                      type="text"
                                      defaultValue={
                                        option.name
                                      }
                                    />

                                    <div className="modifier-option__price">
                                      <span>
                                        +
                                        RM
                                      </span>

                                      <input
                                        type="text"
                                        defaultValue={
                                          option.price
                                        }
                                      />
                                    </div>

                                    <button>
                                      <Trash2
                                        size={
                                          16
                                        }
                                      />
                                    </button>
                                  </div>
                                )
                              )}
                            </div>

                            <button className="modifier-group__add-option">
                              <Plus size={16} />
                              Add option
                            </button>

                            <div className="modifier-group__footer">
                              <button className="modifier-group__remove">
                                Remove
                                group
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  )}

                  <button className="modifier-group__create">
                    <Plus size={16} />
                    Add modifier group
                  </button>
                </div>
              </div>
            </section>
          </div>

          <aside className="edit-product-sidebar">
            <section className="edit-product-card">
              <div className="edit-product-card__header">
                <h3>
                  Display settings
                </h3>
              </div>

              <div className="edit-product-card__body">
                <div className="edit-product-toggle">
                  <div>
                    <h4>
                      Available on menu
                    </h4>

                    <p>
                      Visible and
                      orderable by
                      customers
                    </p>
                  </div>

                  <label className="switch">
                    <input
                      type="checkbox"
                      defaultChecked
                    />

                    <span className="switch__slider" />
                  </label>
                </div>

                <div className="edit-product-toggle">
                  <div>
                    <h4>
                      Best seller
                      badge
                    </h4>
                  </div>

                  <label className="switch">
                    <input type="checkbox" />

                    <span className="switch__slider" />
                  </label>
                </div>
              </div>
            </section>
          </aside>
        </div>
      </main>
    </div>
  )
}